import React, { useContext } from "react";
import { Input, Box } from "@flexisaf/flexibull2";
import PropTypes from "prop-types";
import styled from "styled-components";
import { SchemaContext } from "../container";

const FieldStack = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0;
  padding: 0;
`;

const FieldLabel = styled.label`
  display: block;
  position: static;
  margin: 0 0 0.4rem;
  padding: 0;
  font-size: 0.78rem;
  font-weight: 500;
  letter-spacing: 0;
  text-transform: none;
  color: #5a5368;
  line-height: 1.35;
`;

const InputComponent = (props) => {
  const { errorFields, disabledFields, fieldValue, updateFieldValue } =
    useContext(SchemaContext);

  return (
    <FieldStack>
      {props.props?.label ? (
        <FieldLabel>
          {props.props.label}
          {props.props.required ? (
            <span style={{ color: "#ea2a8a" }}>*</span>
          ) : null}
        </FieldLabel>
      ) : null}
      <Input
        type={props.type}
        {...props.props}
        error={errorFields[props.keyField] || null}
        value={fieldValue?.[props.keyField] || ""}
        onChange={({ target: { value } }) => {
          if (disabledFields.includes(props.keyField)) return;
          updateFieldValue(props.keyField, value);
        }}
        block
        label={null}
        spaceTop={0}
        disabled={disabledFields.includes(props.keyField)}
      />
    </FieldStack>
  );
};

InputComponent.defaultProps = {
  type: "text",
};

InputComponent.propTypes = {
  type: PropTypes.string,
  keyField: PropTypes.string,
};

export default InputComponent;
